import Admins from "../components/Admins.js";
import Nav from "../components/Nav.js";
import { useNavigate } from 'react-router-dom';
import Preloader from "../components/Preloader.js"
import { useEffect, useState } from "react";
import axios from "axios";


const AdminsPage = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = useState(false);
    // const [totalAdmins, setTotalAdmins] = useState(0)
    const [adminActivity, setAdminActivity] = useState(new Date());
    
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    // Add interceptor to log the admin out on error
    api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response.status === 401) {
                // Unauthorized error, log admin out
                sessionStorage.removeItem('token');
                navigate("/login");
            }
            return Promise.reject(error);
        }
    );

    // Update admin activity timestamp whenever there is any admin interaction
    const updateAdminActivity = () => {
        setAdminActivity(new Date());
    };

    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000);

        // Listen for admin interaction events
        window.addEventListener('mousemove', updateAdminActivity);
        window.addEventListener('keydown', updateAdminActivity);

        // Set up the inactivity timeout
        const inactivityTimeout = setInterval(() => {
            const currentTime = new Date();
            const elapsedTime = (currentTime - adminActivity) / 1000; // Convert to seconds
            if (elapsedTime > 180) { // 3 minutes in seconds
                // Admin is inactive for 3 minutes, log them out
                sessionStorage.removeItem('token');
                navigate("/login");
            }
        }, 1000);


        // Cleanup event listeners and timeout when component unmounts
        return () => {
            window.removeEventListener('mousemove', updateAdminActivity);
            window.removeEventListener('keydown', updateAdminActivity);
            clearInterval(inactivityTimeout);
        };
    }, []);

    if (!sessionStorage.getItem('token')) {
        navigate("/login")
    } else {
        if (loading) {
            return (
                <Preloader />
            )
        } else {
            return (
                <>
                    <Nav />
                    <div className="container-fluid">
                        <Admins />
                    </div>

                </>

            )
        }
    }
}
export default AdminsPage